import { Typography } from "@mui/material";
import { makeStyles } from "../../../providers/makeStyles";

const useStyles = makeStyles((theme, { disabled }) => ({
    price: {
        whiteSpace: "nowrap",
        marginLeft: "auto",
        textAlign: "right",
        alignSelf: "center",
        "& .discounted": {
            textDecoration: "line-through"
        }
    }
}));

export const OptionPrice = ({ price, discountPrice }) => {
    const classes = useStyles();

    return (
        <div className={classes.price}>
            {price !== discountPrice &&
            <Typography className="discounted" variant="caption" color="textSecondary">{price}</Typography>}
            <Typography color="textSecondary">{discountPrice}</Typography>
        </div>
    );
};
